import { APP_INITIALIZER } from '@angular/core';
import { StartupService } from './services/startup/startup.service';

const appConfigFactory = (startup: StartupService) => {
  return () => {
      return startup.load();
  };
};

export const AppConfigProvider = {
  provide: APP_INITIALIZER,
  useFactory: appConfigFactory,
  multi: true,
  deps: [StartupService]
};
